const state = {
    hospitalMsg: {
        name: '运营管理平台'
    },
    colorList: [
        'rgb(236, 245, 255)',
        'rgb(217, 236, 255)',
        'rgb(198, 226, 255)',
        'rgb(179, 216, 255)',
        'rgb(160, 207, 255)',
        'rgb(140, 197, 255)',
        'rgb(121, 187, 255)',
        'rgb(102, 177, 255)',
        'rgb(83, 168, 255)',
        'rgb(64, 158, 255)',
    ],

    allIllData: [],
    illUserData: [],
    classifyList: [],

    videoClassifyList: [],

    component_id: '',

    authority: [],

    tumour_type_dict: null, // 大小分类 癌种
    tumour_type_list: null, // 大分类 癌种 区分药
    entry_point_list: null,
    action_list: null,
    points_task_event_list: null,

    stage_list: null,
    line_number_list: null,
    department_list: null,
    schedule_list: null,
    tumour_list: null,
    lose_reason_list: null,
    lose_reason_list2: null,
    medication_type_list: null,
    visit_skeptical: null,
    visit_task_medication_status: null,
    medication_statusList: null,
    drug_code_list: [],
    medication_fields_conf: null,

    city_list: [],
};

const mutations = {
    // 病种
    setAllIllData(state, payload) {
        state.allIllData = payload
    },
    // 患者
    setIllUserData(state, payload) {
        state.illUserData = payload
    },
    // 图文分类
    setLearnClassifyList(state, payload) {
        state.classifyList = payload
    },
    // 视频分类
    setVideoClassifyList(state, payload) {
        state.videoClassifyList = payload
    },

    // 头部tab切换的页面id
    setComponentID(state, payload) {
        state.component_id = payload
    },

    // 保存用户权限
    setPower(state, payload) {
        state.authority = payload
    },
    // 保存公共配置
    setConfig(state, payload) {
        console.log(payload, '公共配置');
        state.tumour_type_dict = payload.tumour_type_dict; // 大小分类病种
        state.entry_point_list = payload.entry_point_list; // 入口
        state.action_list = payload.action_list; // 操作类型
        state.entry_point_action = payload.entry_point_action; // 操作类型
        state.points_task_event_list = payload.points_task_event_list; // 事件类型 积分规则

        // 患者信息所需参数
        state.stage_list = payload.stage_list; // 分期
        state.line_number_list = payload.line_number_list; // 治疗线数
        state.department_list = payload.department_list; // 科室
        state.schedule_list = payload.schedule_list; // 治疗方案
        state.tumour_list = payload.tumour_list; // 癌种
        state.tumour_type_list = payload.tumour_type_list; // 癌种 大分类 区分药
        state.lose_reason_list = payload.lose_reason_list; // 脱落原因
        state.lose_reason_list2 = payload.lose_reason_list2; // 脱落原因2,主观subjective和客观objective
        state.medication_type_list = payload.medication_type;//
        state.visit_skeptical = payload.visit_skeptical; //存疑原因
        if(payload.visit_task_medication_status){
            let list = payload.visit_task_medication_status.map(l => {
                l.value = String(l.value)
                return l
            });
            state.visit_task_medication_status = [{name: '不限', value: ''}, ...payload.visit_task_medication_status]; //跟进情况
            state.medication_statusList = list; //随访工单详情页内跟进情况选项
        }

        state.drug_code_list = payload.drug_code_list; // 药物列表
        state.medication_fields_conf = payload.medication_fields_conf; // 药物  配置项
    },
    // 保存省市（搜索医院用）
    setCityList(state, payload) {
        let cityList = payload;
        cityList.map(v => {
            let list = [];
            v.city_list.map(e => {
                list.push({name: e})
            });
            v.city_list = list
        });
        state.city_list = cityList
    },
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}